import { Component, inject } from '@angular/core';
import { AppInformationService } from 'app/core/app-information.service';
import { AuthService, GenesisUnitOfWork } from 'app/core/core.module';
import { ConfirmationPaymentMethod } from 'app/core/model/confirmation-payment-method';
import { PartConfigModelType } from 'app/core/model/part-config-model-type';
import validationEngine from 'devextreme/ui/validation_engine';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-model-type-dialog',
    template: `
        <div class="modal-header">
            <h2 class="modal-title">Model Type</h2>
        </div>
        <div class="flex-fill d-flex flex-column">
            <div class="card">
                <div class="card-body">
                    <dx-form *ngIf="modelType" [formData]="modelType" validationGroup="validationGroup">
                        <dxi-item itemType="group">
                            <dxi-item dataField="name" [isRequired]="true"></dxi-item>
                            <dxi-item dataField="description"></dxi-item>
                            <dxi-item dataField="hasAxles" [label]="{text: 'Has Axles Qty. Options'}"  editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasBrakes" [label]="{text: 'Has Brake Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasTailOption" [label]="{text: 'Has Tail Option'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasPolyCarpetOption" [label]="{text: 'Has Poly/Carpet Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasSuspension" [label]="{text: 'Has Suspension Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasWinchStand" [label]="{text: 'Has Winch Stand Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasTreeOptions" [label]="{text: 'Has Tree Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasOptions" [label]="{text: 'Has Config Options'}" editorType="dxCheckBox"></dxi-item>
                            <dxi-item dataField="hasToonOption" editorType="dxCheckBox"></dxi-item>
                        </dxi-item>
                    </dx-form>
                </div>
            </div>
        </div>
        <div class="modal-footer">
            <button class="btn btn-danger" (click)="save()">Save</button>
            <button class="btn btn-success" (click)="close()">Close</button>
        </div>
    `,
    standalone: false,
})
export class ModelTypeDialogComponent {
    appInfo = inject(AppInformationService);
    auth = inject(AuthService);
    uow = inject(GenesisUnitOfWork);

    result = new Subject<{ success: boolean }>();
    modelType: PartConfigModelType;
    displayOrder: number;
    validationGroup: 'validationGroup';

    async ngOnInit() {
        await this.getData();
    }

    async getData() {
        if (!this.modelType)
            this.modelType = this.uow.partConfigModelTypes.createEntity({
                displayOrder: this.displayOrder,
                created: new Date(),
                createdBy: this.auth.currentUser?.userName,
            }) as PartConfigModelType;
    }

    async save() {
        if (!this.validate()) return;
        this.result.next({ success: true, value: this.modelType } as any);
    }

    close() {
        this.uow.rollback();
        this.result.next({ success: false });
    }

    validate() {
        const groupConfig = validationEngine.getGroupConfig('validationGroup');
        if (groupConfig) {
            const result = validationEngine.validateGroup('validationGroup');
            if (!result.isValid) {
                let message = '';
                result.brokenRules.forEach((brokenRule) => {
                    if (brokenRule.type === 'custom') message = `${brokenRule.message}\n${message}`;
                });
                this.appInfo.notifyToast(`Please fix errors before saving.\n\n${message}`, 'error');
                return false;
            }
        }
        return true;
    }
}
